export * from './routes';
export * from './sponsor.component';
export * from './sponsor-detail/sponsor-detail.component';
